import { Fragment, useEffect, useMemo } from 'react';
import { useEffectOnce } from 'react-use';
import { playSoundLoop, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { ToggleSound } from '~/components/ui/ToggleSound';
import { useDarkMode } from '~/hooks/useDarkMode';
import { FormContainer } from '../../components/Containers';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { AuthTabs } from '../../redux/slices/authTabsSlice';
import { resetStore } from '../../redux/wrappers';
import { ConfirmEmail } from '../ConfirmEmail';
import { Login } from '../Login';
import { Register } from '../Register';
import { Restore } from '../Restore';
import { RestoreNewPassword } from '../RestoreNewPassword';
import {
	StyledBottomCaptionContainer,
	StyledContentContainer,
} from './AuthPanel.styled';

const AuthPanel = () => {
	const activeTab = useLayoutSelector((state) => state.authTabs.activeTab);
	const dispatch = useLayoutDispatch();
	const isDark = useDarkMode();

	const sound = useMemo(
		() => (isDark ? Sound.CharacterDay : Sound.CharacterNight),
		[isDark],
	);

	const stopSound = useMemo(() => playSoundLoop(sound), [sound]);

	useEffectOnce(() => {
		return () => {
			dispatch(resetStore());
		};
	});

	useEffect(() => {
		return () => {
			stopSound();
		};
	}, [stopSound]);

	return (
		<Fragment>
			<StyledContentContainer>
				<FormContainer>
					{activeTab === AuthTabs.Login && <Login />}
					{activeTab === AuthTabs.Restore && <Restore />}
					{activeTab === AuthTabs.RestoreNewPassword && <RestoreNewPassword />}
					{activeTab === AuthTabs.Register && <Register />}
					{activeTab === AuthTabs.ConfirmEmail && <ConfirmEmail />}
				</FormContainer>
				<StyledBottomCaptionContainer>
					<Text>
						CCDPlanet is not affiliated with or endorsed by Take-Two, Rockstar
						North Interactive, or any other rights holder. All the used
						trademarks belong to their respective owners.
					</Text>
				</StyledBottomCaptionContainer>
			</StyledContentContainer>
			<ToggleSound />
		</Fragment>
	);
};

export { AuthPanel };
